import { useState } from 'react';
import { Check, Copy } from '@/components/icons';
import { copyText } from '@/lib/format';
import { Button, Input } from '@/components/ui';

export function CopyField({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="flex gap-2">
      <Input readOnly value={value} aria-label={label} onFocus={(e) => e.currentTarget.select()} className="font-mono text-xs" />
      <Button
        variant="secondary"
        onClick={async () => {
          if (await copyText(value)) {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
          }
        }}
        icon={copied ? <Check className="size-4 text-emerald-500" /> : <Copy className="size-4" />}
        aria-label={`Copy ${label}`}
      >
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
}
